import React from 'react';
import { isPast } from 'date-fns';
import styles from '../../Styles/Reservations.module.css';
import { labelForHourPadded } from '../../Utils/schema';
import {dayKey, displayDay, isSlotBlockedBy,} from '../../Utils/ReservationsUtil';

function ReservationsDesktopWeekView({
  weekDays,
  hours,
  reservationsByDay,
  blocks,
  getSlotConfig,
  activeCalendarId,
  companyColors,
  user,
  onClickSlot,
}) {
  return (
    <div className={styles.weekview}>
      {weekDays.map((dateObj, di) => {
        const key = dayKey(dateObj);
        return (
          <div key={di} className={styles.day}>
            <h3>{displayDay(dateObj)}</h3>
            {hours.map((hour, idx) => {
              // 1) Onko slotissa sulku?
              const hit = (blocks || [])
                .map((b) => ({ b, r: isSlotBlockedBy(b, dateObj, hour) }))
                .find((x) => x.r.blocked);
              if (hit) {
                return (
                  <div
                    key={idx}
                    className={styles.slot}
                    style={{
                      backgroundColor: '#222',
                      color: '#fff',
                      cursor: 'not-allowed',
                    }}
                    title={hit.r.title}
                  >
                    {hit.r.title}
                  </div>
                );
              }
              // 2) Muuten normaali logiikka
              const res = reservationsByDay[key]?.[idx];
              const sc = getSlotConfig(activeCalendarId, dateObj, hour);
              const slotDate = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), hour, 0, 0);
              const past = isPast(slotDate);
              const baseCls = [styles.slot];
              if (past || !sc.open) baseCls.push(styles.past);
              let bg = '';
              if (res && res.talonyhtiöid) {
                bg = companyColors[res.talonyhtiöid] || '';
              }
              const text = res
                ? `${res.sukunimi || ''}${
                    Number(res.hinta || 0) > 0 ? ` (${Number(res.hinta)}€)` : ''
                  }`
                : labelForHourPadded(hour);
              const cursor =
                !sc.open || past || (res && res.id !== user.uid)
                  ? 'not-allowed'
                  : 'pointer';
              return (
                <div
                  key={idx}
                  className={baseCls.join(' ')}
                  style={{ backgroundColor: bg || undefined, cursor }}
                  onClick={() => onClickSlot(dateObj, hour)}
                >
                  {text}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

export default ReservationsDesktopWeekView;